import { store, getElement } from '@wordpress/interactivity';

import './frontend.scss';

const { callbacks } = store('itp/social-carousel-images', {
  callbacks: {
    initCarousel() {
      const el = getElement();
      const index = el?.getAttribute('data-index');
      callbacks.duplicateContent(index);
    },
    duplicateContent(index) {
      const { ref } = getElement();
      const elWidth = ref.offsetWidth + 32;
      const windowWidth = window.screen.width;

      const duplicateNum = Math.ceil(windowWidth / elWidth) - 1;

      const parent = document.querySelector(
        `.wp-block-itp-social-carousel__container[data-index="${index}"]`,
      );

      for (let i = 0; i < duplicateNum; i++) {
        const clone = ref.cloneNode(true);
        parent.appendChild(clone);
      }
    },
  },
});
